import React, { type PropsWithChildren, useState, type FC, type ReactElement } from 'react'
import styles from './SlideDown.module.css'

const SlideDown: FC<
  PropsWithChildren<{
    Button: ReactElement
    isShowDefault?: boolean
    isShowToggle?: (isShow: boolean) => void
  }>
> = ({ Button, children, isShowDefault, isShowToggle }) => {
  const [show, setShow] = useState<boolean>(isShowDefault || false)

  const onClick = () => {
    const currentState = show
    setShow(() => !currentState)
    isShowToggle && isShowToggle(!currentState)
  }

  return (
    <>
      {React.cloneElement(Button, { onClick })}
      {/* <div className={`${styles.slidePanel} ${show ? styles.show : styles.hide}`}>{children}</div> */}
      <div className={`${show ? '' : 'hidden'}`}>{children}</div>
    </>
  )
}

export default SlideDown
